import { useEffect } from 'react';

export interface SiteConfig {
  isGallery: boolean;
  name: string;
  shortName: string;
  domain: string;
  title: string;
  description: string;
  supportEmail: string;
  appStoreUrl: string;
  getAppButtonText: string;
  downloadButtonText: string;
  whyTitle: string;
  footerCopyright: string;
}

export function isGallerySite(): boolean {
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname.toLowerCase();
    if (
      hostname.includes('gallery') ||
      hostname.includes('watchi-faces-gallery') ||
      hostname.includes('46.62.129.76')
    ) {
      return true;
    }
  }

  if (
    process.env.REACT_APP_SITE_MODE === 'gallery' ||
    process.env.REACT_APP_IS_GALLERY === 'true'
  ) {
    return true;
  }

  return false;
}

export function getSiteConfig(): SiteConfig {
  const isGallery = isGallerySite();

  if (isGallery) {
    return {
      isGallery: true,
      name: 'Watchi Faces Gallery',
      shortName: 'Watchi Faces Gallery',
      domain: 'watchi-faces-gallery.app',
      title: 'Watchi Faces Gallery — Fresh Smart Watch Faces & Widgets',
      description:
        'Watchi Faces Gallery curates Smart Watch faces, widgets and matching wallpapers so your watch feels personal every day.',
      supportEmail: 'support@watchi.app',
      appStoreUrl:
        'https://apps.apple.com/us/app/watchi-watch-faces-gallery/id6753596004',
      getAppButtonText: 'Get Watchi Faces Gallery',
      downloadButtonText: 'Download Watchi Faces Gallery',
      whyTitle: 'Why Watchi Faces Gallery',
      footerCopyright: `© ${new Date().getFullYear()} Watchi Faces Gallery — Crafted for Smart Watch fans worldwide.`,
    };
  }

  return {
    isGallery: false,
    name: 'Watchi',
    shortName: 'Watchi',
    domain: 'watchi.app',
    title: 'Watchi.app — Fresh Apple Watch Faces & Widgets',
    description:
      'Watchi.app curates Apple Watch faces, widgets and matching wallpapers so your watch feels personal every day.',
    supportEmail: 'support@watchi.app',
    appStoreUrl:
      'https://apps.apple.com/us/app/watchi-watch-faces-gallery/id6753596004',
    getAppButtonText: 'Get Watchi',
    downloadButtonText: 'Download Free',
    whyTitle: 'Why Watchi',
    footerCopyright: `© ${new Date().getFullYear()} Watchi.app — Crafted for Apple Watch fans worldwide.`,
  };
}

export function useSiteConfig(): SiteConfig {
  const config = getSiteConfig();

  useEffect(() => {
    document.title = config.title;

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', config.description);
    }
  }, [config.title, config.description]);

  return config;
}
